// extracted by mini-css-extract-plugin
module.exports = {"dialogPetBusinessLicense":"DialogPetBusinessLicense_dialogPetBusinessLicense_13BJF"};